<template>
  <div class="web-004-home-mobile">
    <carousel
      v-if="rotationList.length"
      :list="rotationList"
    />
    <img src="@/assets/web004/home/mobile-1.png">
    <img src="@/assets/web004/home/mobile-2.png">
    <img src="@/assets/web004/home/mobile-3.png">
    <div
      class="rollingPictureBar-container"
    >
      <div class="title">
        荣 誉 ｜ 责任之始，传承之光
      </div>
      <rollingPictureBar :images="honors" />
      <div class="title">
        优学派AI智习室实景
      </div>
      <rollingPictureBar :images="scenes" />
    </div>
  </div>
</template>

<script>
import api from '../../../proxy';
import carousel from '../../components/carousel.vue';
import rollingPictureBar from '../../components/rollingPictureBar.vue';
export default {
    name: 'Mobile',
    components: {
        carousel,
        rollingPictureBar,
    },
    data () {
        return {
            rotationList: [],
            honors: [
                require('@/assets/web004/home/honor1.png'),
                require('@/assets/web004/home/honor2.png'),
                require('@/assets/web004/home/honor3.png'),
                require('@/assets/web004/home/honor4.jpg'),
                require('@/assets/web004/home/honor5.png'),
                require('@/assets/web004/home/honor6.jpg'),
                require('@/assets/web004/home/honor7.jpg'),
                require('@/assets/web004/home/honor8.jpg'),
                require('@/assets/web004/home/honor9.png'),
                require('@/assets/web004/home/honor10.png'),
                require('@/assets/web004/home/honor11.jpg'),
            ],
            scenes: [
                require('@/assets/web004/home/s1.jpg'),
                require('@/assets/web004/home/s2.jpg'),
                require('@/assets/web004/home/s3.jpg'),
                require('@/assets/web004/home/s4.jpg'),
                require('@/assets/web004/home/s5.jpg'),
                require('@/assets/web004/home/s6.jpg'),
                require('@/assets/web004/home/s7.jpg'),
                require('@/assets/web004/home/s8.jpg'),
                require('@/assets/web004/home/s9.jpg'),
                require('@/assets/web004/home/s10.jpg'),
                require('@/assets/web004/home/s11.jpg'),
                require('@/assets/web004/home/s12.jpg'),
                require('@/assets/web004/home/s13.jpg'),
                require('@/assets/web004/home/s14.png'),
            ],
        };
    },
    async created () {
        const { siteId } = this.$route.query;
        if (!siteId) return;
        const res = await api.getRotationList({
            siteId,
            pageNo: 1,
            pageSize: 999,
        });
        if (res.errcode === 0) {
            this.rotationList = res.data.list.filter(itm => itm.status === 1 && [0, 2].includes(itm.clientType));
        } else {
            this.$message.error(res.errmsg);
        }
        this.loading = false;
    },
};
</script>

<style scoped lang="scss">
.web-004-home-mobile {
    width: 100%;
    height: 100%;
    >img {
        width: 100%;
    }
    .rollingPictureBar-container {
        width: 100%;
        height: 580px;
        background-size: 100%;
        background-repeat: no-repeat;
        background-image: linear-gradient(to bottom, #d7e3fe, #eef5ff);
        .title {
            color: #141414;
            font-size: 14px;
            text-align: center;
            padding-top: 20px;
            padding-bottom: 20px;
            font-weight: 600;
        }
    }
}
</style>
